import {apiBase} from './ApiBase'
import camelcaseKeys from "camelcase-keys"
import {TemporaryFile} from "@/entity/TemporaryFile";

export const addTemporaryFile = async ({ temporaryFile }) => {
  const result = await apiBase.post(`/temporaryFile`, temporaryFile.export())
  return new TemporaryFile(camelcaseKeys(result.data.data, { deep: true }))
}

export const getFile = async ({id}) => {
  const result = await apiBase.get(`/file/${id}`, {}, { responseType: 'blob' })
  return result.data
}
